import BotoBuscar from "./BotoBuscar";
import BotoPestanyaUp from "../controller/botons/BotoPestanyaUp";
import BotoPestanyaDown from "../controller/botons/BotoPestanyaDown";

function ReadOnlyButtons({ caixaSelected, panzoom, castellersInfo, posicions, setCaixaSelected, tabs, pestanya, setPestanya }) {
    return (
        <div
            className="readonly-buttons-container"
            style={{
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    zIndex: 99999999,
                    gap: 10,
                    position: 'fixed',
                    bottom: 25,
                    left: 25,
                }}
            >
                <BotoPestanyaUp
                    tabs={tabs}
                    pestanya={pestanya}
                    setPestanya={setPestanya}
                    readonly={true}
                />

                <BotoPestanyaDown
                    tabs={tabs}
                    pestanya={pestanya}
                    setPestanya={setPestanya}
                    readonly={true}
                />
            </div>
        </div>
    )
}

export default ReadOnlyButtons;